import { render } from "./UsersListEditModal.vue?vue&type=template&id=c5f0f620"
import script from "./UsersListEditModal.vue?vue&type=script&lang=js"
export * from "./UsersListEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__